export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13111.367571f4.jpg";